import React,{ useEffect } from "react";
import store from "../store";
import { delay } from "../utils/react-utils";
import { requestJSON } from "../utils/request-module";
import ParameterInput from "./parameter-input";
import { useStepIndex } from "./step-index-context";
const SHOW_BLOCKS=window['config'].SHOW_BLOCK_PER_TX
export default function BlockEdit(){
  if(!SHOW_BLOCKS) return null

  var stepIndex=useStepIndex()
  useEffect(()=>{
    if(!SHOW_BLOCKS) return
    var cancel=false;
    (async()=>{
      // if(!store.steps[stepIndex].blockNumber) {
      await delay(200)
      if(cancel) return
      var lastblock=await requestJSON('GET','/get-block?number=' + (store.steps[stepIndex].blockNumber || '',null,true))
      if(cancel) return
      if(lastblock.number) {
        store.steps[stepIndex].blockNumber=String(lastblock.number)
        store.steps[stepIndex].blockTimestamp=lastblock.timestamp
        store.steps[stepIndex].blockTimestampDisbaled=true
      } else {
        // store.steps[stepIndex].blockTimestamp?=new Date().valueOf()/1000
        store.steps[stepIndex].blockTimestampDisbaled=false
      }
      store.updateStore()
      if(cancel) return
      // }
    })();
    return ()=>{
      cancel=true
    }
  },[store.steps[stepIndex].blockNumber,store.steps[stepIndex].manualBlock])

  var step=store.steps[stepIndex]
  return <>
    {!step.manualBlock && <div>
    <b>Block Number: </b>&nbsp;Latest&nbsp;
    <span 
      style={{textDecoration:'underline',cursor:'pointer'}} 
      onClick={e=>{
      store.steps[stepIndex].manualBlock=true
      delete store.steps[stepIndex].blockNumber
      store.updateStore()
    }}>Change (advanced)</span>
    </div>}
    {step.manualBlock && <div>
      <br/>
    <ParameterInput 
        label="Block number"
        type="uint"
        value={store.steps[stepIndex].blockNumber || ''} 
        disabled={store.isReadOnly}
        onChange={e=>{
          store.steps[stepIndex].blockNumber=e.target.value
          store.updateStore()
        }}
    />
    <br/><br/>
    <ParameterInput 
    label="Block timestamp"
        type="timestamp"
        disabled={step.blockTimestampDisbaled || store.isReadOnly}
        value={store.steps[stepIndex].blockTimestamp} 
        onChange={e=>{
          store.steps[stepIndex].blockTimestamp=e.target.value
          store.updateStore()
        }}
    />        
    <br/>
    <span style={{textDecoration:'underline',cursor:'pointer'}} onClick={()=>{
      step.manualBlock=false
      store.updateStore()
    }}>&lt; Back to latest block</span>
    </div>
    }
    </>
}